import{ GET_VFOVISIT_FORM_DETAIL,GET_SINGLE_VFO_VISIT } from "../../../Types";

const initialState = {
  VFOVisitDetailList: {},
  SingleVFODetail:{}
  };

const VFODailyVistSummariesReducer = (state = [], action) => {
  switch (action.type) {
    case GET_VFOVISIT_FORM_DETAIL:
        return { ...state, VFOVisitDetailList: action.payload, };
        case GET_SINGLE_VFO_VISIT:    
        return { ...state, SingleVFODetail: action.payload, };
    default:
      return state
  }
}
export default VFODailyVistSummariesReducer;


